module.exports = function(service) {
	'use strict'
	service.factory('copyLink', copyLink);
	copyLink.$inject = ['$timeout'];
	function copyLink($timeout) {
	    return function(event, copyValue, toltipText,toltipEle) {
            if(document.querySelector('.'+toltipEle)) return
            var element = event.currentTarget;
            var textArea = document.createElement("textarea");
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;
            textArea.style.width = '0.4em';
            textArea.style.height = '0.4em';
            textArea.style.padding = 0;
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            textArea.value = copyValue;
            textArea.class = 'copy-textarea';
            if (!document.querySelector("textarea.copy-textarea")) {
                document.body.appendChild(textArea);
            }
            textArea.select();
            document.execCommand("Copy");
            document.body.removeChild(textArea);
            if(!document.querySelector('.'+toltipEle)) {
                var copiedTitle = document.createElement("span");
                copiedTitle.innerText = toltipText;
                copiedTitle.classList.add(toltipEle, 'toltip-el');
                element.appendChild(copiedTitle);
            }
            $timeout(function() {
                if(document.querySelector('.'+toltipEle)) {
                    document.querySelector('.'+toltipEle).parentNode.removeChild(document.querySelector('.'+toltipEle));
                }
            },1500)
        }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/copyLinkService.js
// module id = 591
// module chunks = 0